import React, { useState,useMemo, useCallback } from 'react'

import { AppBar, UserMenu, 
  // SidebarToggleButton, Logout, 
  useCreate, useRedirect, usePermissions, useNotify } from "react-admin";
import { withStyles } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core';
import Avatar from "@material-ui/core/Avatar";
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import { toEnglishDigits } from '../utils/utils';

import {
  Button, Dialog, Modal,
} from '@mui/material';
import Person from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';
import {
  // Search, SearchResultItem, 
  useSearch,
  SearchResultContextProvider,
  SearchResultsPanel,
} from '@react-admin/ra-search';

import { PersonPinCircleOutlined } from '@material-ui/icons';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import SdStorageIcon from '@mui/icons-material/SdStorage';
import Add from '@material-ui/icons/Add';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { ROLES, SERVER } from '../constants';
// import { AUTH_TYPES } from '../auth/authConstants';
import { HttpClient } from '../utils/requests';
import { isMobile } from 'react-device-detect';
// import * as libphonenumber from 'libphonenumber-js';

const styles = {
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  spacer: {
    flex: 1,
  },
}
const useStyles = makeStyles(theme => ({
  menuItem: {
    color: theme.palette.text.secondary
  },
  avatar: {
    height: 30,
    width: 30
  },
  icon: { minWidth: theme.spacing(5) },
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));

export const RenderIconSwitch = (prop) => {
  let param = prop.data
  // document.getElementById("buttonCreateContact").style.visibility = "hidden";
  switch (param.type) {
    case 'contact':

      return (
        <div style={{ padding: "30px" }}>
          <PersonPinCircleOutlined />

          <span>{param.customData.name}</span>
          <p>{param.customData.phoneNumbers.map(a => a.number + "  ,  ")}</p>

          <div style={isMobile ? {} : { display: 'flex' }}>

            <Button
              startIcon={<Add style={{ paddingLeft: "8px" }} />}
              color="primary" variant="contained"
              component={Link}
              style={{ margin: "20px" }}

              to={{
                pathname: '/need/create',
                state: { record: { contactId: param.content.id, contactRefNum: param.content.label } },
              }}
            >
              درخواست
            </Button>
            <Button
              startIcon={<Add style={{ paddingLeft: "8px" }} />}
              color="primary" variant="contained"
              component={Link}
              style={{ margin: "20px" }}

              to={{
                pathname: '/clue/create',
                state: {
                  record: {
                    phoneNumber: param.customData.phoneNumbers[0]?.number,
                    users: param.customData.users,
                    contactName: param.customData.name,
                    contactId: param.content.id, contactRefNum: param.content.label
                  }
                },
              }}
            >
              سرنخ
            </Button>

            <Button
              startIcon={<Add style={{ paddingLeft: "8px" }} />}
              color="primary" variant="contained"
              component={Link}
              style={{ margin: "20px" }}

              to={{
                pathname: '/reminder/create',
                state: {
                  record: {
                    phoneNumber: param.customData.phoneNumbers[0]?.number,
                    users: param.customData.users,
                    contactName: param.customData.name,
                    contactId: param.content.id, contactRefNum: param.content.label
                  }
                },
              }}
            >
              یادآوری
            </Button>
          </div>
        </div>
      )
    case 'need':
      return <LiveHelpIcon />
    case 'storage':
      return <SdStorageIcon />
    default:
      return 'foo';
  }
}
const renderLinkSwitch = (param) => {
  switch (param.type) {
    case 'contact':
      return param.url + "/show";
    case 'need':
      return param.url + "/edit";
    case 'storage':
      return param.url + "/show";
    default:
      return param.url + "/show";
  }
}

const MySearchResultItem = ({ data, onClose }) => {
  return (
    <div >
      <li key={data.id} style={{ background: "#87d3ff", position: "absolute", top: "38px" }}>
        <Link to={renderLinkSwitch(data)} onClick={onClose}>
          {/* <div>
            <>
              <span>{data.content.label}</span>
            </>
          </div> */}
          {/* <p>{data.content.description}</p> */}
          <RenderIconSwitch data={{ ...data }} />
        </Link>

      </li>
    </div>
  )
};

// var isOpend = false;

const MySearch = () => {

  const [query, setQuery] = React.useState();
  const [search, searchResultState] = useSearch();
  const [open, setOpen] = useState(false);
  const handleChange = (event) => {
    let phone = event.target.value
    phone = toEnglishDigits(phone)
    // phone = libphonenumber.parsePhoneNumber(phone, "IR").formatNational().replace(/[^0-9&^۰-۹]/g, '');


    setQuery(phone);
    if (!isNaN(parseFloat(phone)))
      localStorage.setItem('last_search_query', phone)
    search(phone)
    setOpen(true);

  };
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []); 
  const contextValue = useMemo(() => ({
    onClose: handleClose,
    ...searchResultState,
  }), [handleClose, searchResultState]);
    return (
    <>
      <TextField 
      sx={{ margin: "8px", minWidth: "100px" }}
      
      placeholder="شماره مخاطب" variant="standard" value={query} onFocus={handleChange} onChange={handleChange} />
      <Modal
        open={open}
        onClose={handleClose}
        BackdropProps={{
          style: {
            backgroundColor: "transparent", // Make the backdrop transparent
          },
        }}
        aria-labelledby="modal-modal-title"
      >
        <SearchResultContextProvider value={contextValue}>
          <SearchResultsPanel >
            <MySearchResultItem />
          </SearchResultsPanel>
        </SearchResultContextProvider>
      </Modal>
    </>
    //   <Search>
    //     <SearchResultsPanel>
    //       {/* <li key={(record) => (record.id)}>
    //         <Link to={(record) => (record.url)} >
    //           <strong>{(record) => (record.content.label)}</strong>
    //         </Link>
    //         <p>{(record) => (record.content.description)}</p>
    //       </li> */}
    //       <MySearchResultItem />
    //       {/* <SearchResultItem
    //         label={(record) => (<div>{renderIconSwitch(record.type)}
    //           <>
    //             <span>{record.content.label}</span>
    //           </>
    //         </div>)} /> */}
    //     </SearchResultsPanel>
    //   </Search>
  )
};

const MyAppBar = withStyles(styles)(({ classes, ...props }) => {
  const { permissions } = usePermissions();

  return (
    <AppBar userMenu={<MyUserMenu icon={<MyCustomIcon />} />} {...props}>
      {/* <Typography
            variant="title"
            color="inherit"
            className={classes.title}
            id="react-admin-title"
        /> */}
      <span className={classes.spacer} />
      {/* <IconButton color="inherit" >
            <BackIcon/>
        </IconButton> */}
      {/* <Button
      id="buttonCreateContact"
      color="primary" variant="outlined"
      component={Link}
      style={{ margin: "20px" }}

      to={{
        pathname: '/contact/create',
        state: { record: {  } },
      }}
    >
      ایجاد  مخاطب
    </Button> */}
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        ایجاد  مخاطب
      </Button> */}
      {(permissions?.includes(ROLES.SUPER_ADMIN) ||
        permissions?.includes(ROLES.MANAGER_CRM) ||
        permissions?.includes(ROLES.SALE_CRM_ADMIN) ||
        permissions?.includes(ROLES.UNIT_CRM_USER) ||
        permissions?.includes(ROLES.USER_CRM_SIMPLE))
        ? <FormDialog /> : <></>}
      <MySearch id="searchResult" />
    </AppBar>
  )
}
)
const MyUserMenu = props => (
  <UserMenu {...props}>
    <ProfileMenu />
    {/* <SidebarToggleButton /> */}
  </UserMenu>
);

const MyCustomIcon = () => {
  const classes = useStyles();
  return (
    <>
      <Avatar
        className={classes.avatar}
        src="profile.png"
      />
      {!isMobile ? <span style={{ marginRight: 8 }}><b>{localStorage.getItem("username")}</b></span> : null}

    </>
  );
};

const ProfileMenu = React.forwardRef((props, ref) => {
  return (
    <MenuItem
      ref={ref}
      component={Link}
      // It's important to pass the props to allow MUI to manage the keyboard navigation
      {...props}
      to="/my-profile"
    >

      <ListItemIcon>
        <div>
          <Person />
          {localStorage.getItem("username")}
        </div>

      </ListItemIcon>

    </MenuItem>
  );
});

function FormDialog() {

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');
  // const [phoneNumber, setPhoneNumber] = React.useState(localStorage.getItem('last_search_query'));
  // const [contactData, setContactData] = React.useState({ contact: undefined })
  const [disableInput, setDisableInput] = React.useState(false)

  const notify = useNotify();

  const redirect = useRedirect();

  const [create] = useCreate();

  const handleSubmit = event => {
    event.preventDefault();
    let phoneNumber = localStorage.getItem('last_search_query')
    if (phoneNumber) {

      HttpClient(SERVER + `/admin/contact/phone/` + phoneNumber, {
        method: "GET",
      })
        .then(({ headers, json }) => {
          if (json.result) {
            // setContactData(json.result)
            setDisableInput(true)
            // setValue("contactName", json.result.name);
            // form.change("contactName", json.result.name);
            notify(` مخاطب با این شماره وجود دارد  : ${json.result.name}`, { type: 'warning' });
          } else {
            setDisableInput(false)
            create("contact",
              { name: value, phoneNumbers: [{ number: phoneNumber }] },
              {
                onSuccess: ({ data }) => { setOpen(false); redirect('/contact/' + data.id + '/show',) },
                onFailure: (error) => {
                  console.log(error)
                  setOpen(true);
                }
              }
            );
          }

        })
        .catch((e) => {
        });
    }


  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setDisableInput(false)
    setOpen(false);
  };
  const handlePhoneChange = (event) => {
    localStorage.setItem('last_search_query', event.target.value)
    // const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
    HttpClient(SERVER + `/admin/contact/phone/` + event.target.value, {
      method: "GET",
    })
      .then(({ headers, json }) => {
        if (json.result) {
          // setContactData(json.result)
          setDisableInput(true)
          // setValue("contactName", json.result.name);
          // form.change("contactName", json.result.name);
          notify(` مخاطب با این شماره وجود دارد  : ${json.result.name}`, { type: 'warning' });

        } else {
          setDisableInput(false)

        }

      })
      .catch((e) => {
      });

  }

  return (
    <div>
      <Button variant="contained" id="" style={{ background: "#ff5722", borderRadius: "10px" }} onClick={handleClickOpen}>
        {!isMobile ? 'ایجادِ مخاطب' : "+"}
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>ایجاد مخاطب</DialogTitle>
        <DialogContent>
          <DialogContentText>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="نام مخاطب"
            onChange={event => setValue(event.target.value)}

            variant="standard"
          />
          <br />
          <TextField
            margin="dense"
            id="phoneNumber"
            label="شماره"
            variant="standard"
            defaultValue={localStorage.getItem('last_search_query')}
            // onChange={event => setPhoneNumber({ number: event.target.value })}
            onChange={handlePhoneChange}

          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>فعلا نه</Button>
          <Button onClick={handleSubmit} disabled={disableInput}>ایجاد مخاطب</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default MyAppBar
